import React, {Component} from 'react';

import Registry from '../../../registry/index';

function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
}

function setCookie(name, value, seconds) {
    const expires = new Date(Date.now() + seconds * 1000).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; expires=${expires}`;
}

function deleteCookie(name) {
    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}

class LoginForm extends Component {

    constructor(props) {
        super(props);

        const nick = props.currentUser && props.currentUser.nick || '';

        this.state = {
            formData: {
                nick: this.props && this.props.currentUser && this.props.currentUser.nick ?  this.props.currentUser.nick : '',
                password: ''
            },
            error: '',
            isLoading: false,
            isNickDisabled: !!nick,
        };

        this._onError = this._onError.bind(this);
        this._onSuccess = this._onSuccess.bind(this);
        this._onLogoutSuccess = this._onLogoutSuccess.bind(this);
    }

    sendData(e) {
        let siteInterface = Registry.get('siteInterface');
        siteInterface.login(this.state.formData).then(this._onSuccess).catch(this._onError);
        e.preventDefault();
    }

    logout(e) {
        let siteInterface = Registry.get('siteInterface');

        this.setState({isLoading: true});

        siteInterface.logout(this.state.formData).then(this._onLogoutSuccess).catch(this._onError);
        e.preventDefault();
    }

    _onSuccess(_response) {
        let siteInterface = Registry.get('siteInterface');
        let chatInterface = Registry.get('chatInterface');

        const VISITED = getCookie('VISITED') || '';
        if (typeof window !== 'undefined' && _response.data.user.age_verified === 0) {
            try {
                window.ageverif.start({ closable: true });
            } catch (e) {
                console.error('AgeVerify init error:', e);
            }
        } else {
            if (_response.data.user.age_verified === 1 && !VISITED) {
                const entries = VISITED.split(',').filter((entry) => entry != '');
                entries.push('/disclaimer/');
                setCookie('VISITED', entries.join(','), 86400);
                if (window.closeDisclaimer) window.closeDisclaimer();
            }
        }

        if(chatInterface.isLoggedIn()) chatInterface.logout();

        chatInterface.setAuthParams({
            current_user: _response.data.user
        });

        this.setState({
            formData: {
                nick: '',
                password: ''
            },
            error: ''
        });

        window.setTimeout(function() {
            chatInterface.login(
                () => siteInterface.refreshParentWindowUser()
            );
        }, 300);

        this.props.close();
    }

    _onLogoutSuccess () {
        let siteInterface = Registry.get('siteInterface');
        let chatInterface = Registry.get('chatInterface');

        deleteCookie('VISITED');
        window.ageverif.clear()

        if(chatInterface.isLoggedIn()) chatInterface.logout();

        chatInterface.setAuthParams({
            current_user: null
        });

        this.setState({
            formData: {
                nick: '',
                password: ''
            },
            error: '',
            isNickDisabled: false,
            isLoading: false
        });

        window.setTimeout(function() {
            chatInterface.login(
                () => siteInterface.refreshParentWindowUser()
            );
        }, 300);


        window.location.reload();
        // this.props.close();
    }

    _onError(exception) {
        this.setState({error: exception.message});
    }

    handleChange (event) {
        this.setState({
            formData: {
                ...this.state.formData,
                [event.target.name]: event.target.value
            }
        });
    }


    render() {
        let lang = Registry.get('locale');

        let {
            error,
            formData
        } = this.state;

        let disabledEnter = !formData.nick || !formData.password ? 'disabled' : '';

        let formClassName = 'login-form content';
        if (this.props.currentUser) formClassName += ' login-form-ageverif';

        return (
            <div className={formClassName}>
                <form onSubmit={e => this.sendData(e)}>
                    <input
                        name="nick"
                        type="text"
                        placeholder={lang.nick}
                        value={formData.nick}
                        onChange={e => this.handleChange(e)}
                        disabled={this.state.isNickDisabled || this.state.isLoading}
                    />
                    <input
                        name="password"
                        type="password"
                        placeholder={lang.password}
                        value={formData.password}
                        onChange={e => this.handleChange(e)}
                        disabled={this.state.isLoading}
                    />
                    <button
                        className="popup-button primary"
                        disabled={disabledEnter || this.state.isLoading}
                        onClick={e => this.sendData(e)}
                        style={{marginBottom: '10px'}}
                    >{lang.enter}</button>
                    {this.state.isNickDisabled && <a href="#" className="forgot-password" onClick={(e) => {
                        this.logout(e);
                    }}>{lang.logout}</a> }
                    <div></div>
                    <a href="#" className="forgot-password" onClick={() => this.props.switchTab(3)}>{lang.forgot_password}</a>
                    <p className="error" dangerouslySetInnerHTML={{__html: error}} />
                </form>
            </div>

        );
    }
}

export default LoginForm;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/AnonymousLoginPopup/LoginForm.js